<template>
    <main>
        <div class="m-header">
            <div class="top"></div>
        </div>
        <div class="bg">
            <div class="banner">
                <div class="top-box">
                    <div class="title-box">
                        <div class="title"></div>
                    </div>
                </div>
            </div>
            <div class="login-box">
                <div class="login">
                    <div class="tab">
                        <div class="item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)"
                            v-if="!smsLoginDisabled">验证码登录</div>
                        <div class="item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)"
                            v-if="disasterRecoveryEnabled">密码登录</div>
                    </div>
                    <div class="info">
                        <div class="item" :class="[tab == 1 ? 'active' : '']" v-if="disasterRecoveryEnabled">
                            <div class="input" :class="[error.username ? 'error' : '']">
                                <span class="left icon icon-user"></span>
                                <input type="text" class="left in" placeholder="请输入邮箱账号/手机号"
                                    @blur="validate('username')" v-model="username">
                            </div>
                            <div class="validate">{{ error.username }}</div>
                            <div class="input" :class="[error.password ? 'error' : '']">
                                <span class="left icon icon-password"></span>
                                <input type="password" class="left in" placeholder="请输入密码" @blur="validate('password')"
                                    v-model="password">
                            </div>
                            <div class="validate">{{ error.password }}</div>
                        </div>
                        <div class="item" :class="[tab == 2 ? 'active' : '']" v-if="!smsLoginDisabled">
                            <div class="input" :class="[error.phone ? 'error' : '']">
                                <span class="left icon icon-phone"></span>
                                <input type="text" class="left in" placeholder="请输入手机号码" @blur="validate('phone')"
                                    v-model="phone">
                            </div>
                            <div class="validate">{{ error.phone }}</div>
                            <div class="input" :class="[error.code ? 'error' : '']">
                                <span class="left icon icon-message"></span>
                                <input type="text" maxlength="6" class="left in" @blur="validate('code')"
                                    placeholder="请输入验证码" v-model="code">
                                <span class="left btn" :class="code_status ? '' : 'hidden'"
                                    @click="getCode">{{ code_text }}</span>
                            </div>
                            <div class="validate">{{ error.code }}</div>
                        </div>
                        <div class="submit" @click="doLogin">登录</div>
                        <div class="action">
                            <div class="left link" @click="toRegister">立即报名</div>
                            <!--                            <div class="right link" @click="show_tab1 = true;tab= 1;" id="pwlogin" style="display:none;">密码登录</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <service></service>
    </main>
</template>

<script>
import Service from "../../components/m/Service";
import util from "@/common/util";
export default {
    name: 'plan',
    data() {
        return {
            query: "",
            tab: 2,
            show_tab1: false,
            username: "",
            password: "",
            phone: "",
            code: "",
            code_text: "获取验证码",
            code_status: true,
            error: {},
            // 灾备相关
            disasterRecoveryEnabled: false, // 是否启用灾备模式（密码登录）
            smsLoginDisabled: false, // 是否禁用短信登录
        }
    },
    props: {

    },
    components: {
        Service

    },
    computed: {

    },
    methods: {
        // 检查灾备状态
        checkDisasterRecovery() {
            // 检查登录类型
            this.http.request({
                api: 'auth/loginType',
                async: 1,
                success: (res) => {
                    if (res && res.loginType === 1) {
                        // loginType为1时启用密码登录
                        this.disasterRecoveryEnabled = true;
                        // 启用灾备时直接禁用短信登录
                        this.smsLoginDisabled = true;
                        // 自动切换到密码登录
                        this.tab = 1;
                    } else {
                        // loginType为0或其他值时使用验证码登录
                        this.disasterRecoveryEnabled = false;
                        this.smsLoginDisabled = false;
                        this.tab = 2;
                    }
                },
                error: (res) => {
                    // 接口调用失败时，保持默认状态（验证码登录）
                    console.log('登录类型检查失败:', res);
                    this.disasterRecoveryEnabled = false;
                    this.smsLoginDisabled = false;
                    this.tab = 2;
                }
            });
        },

        toRegister() {
            this.$router.push({
                path: "/register",
                query: {
                    from: this.$route.query.from ? this.$route.query.from : (this.$route.path == '/login' || this.$route.path == '/register') ? '/' : this.$route.fullPath
                }
            })
        },
        validate(field) {
            var message = "";
            switch (field) {
                case 'username':
                    if (!this.username) {
                        message = "请输入邮箱账号/手机号";
                    } else if (!this.tool.type.checkStr(this.username, 'email') && (this.isCn() && !this.tool.type.checkStr(this.username, 'phone'))) {
                        message = "邮箱账号/手机号格式不正确";
                    } else {
                        message = "";
                    }
                    break;
                case 'password':
                    if (!this.password) {
                        message = "请输入密码";
                    } else {
                        message = "";
                    }
                    break;
                case 'phone':
                    if (!this.phone) {
                        message = "请输入手机号码";
                    } else {
                        const isEmail = this.tool.type.checkStr(this.phone, 'email');
                        const hasEmailPrefix = this.phone.includes('@');

                        if (hasEmailPrefix && !isEmail) {
                            message = "邮箱账号格式不正确";
                        } else if (!isEmail && (this.isCn() && !this.tool.type.checkStr(this.phone, 'phone'))) {
                            message = "手机号码格式不正确";
                        } else {
                            message = "";
                        }
                    }
                    break;
                case 'code':
                    if (!this.code) {
                        message = "请输入验证码";
                    } else {
                        message = "";
                    }
                    break;
                default:
                    break;

            }
            this.setError(field, message);
            return message ? false : true;
        },
        setError(name, message = "") {
            this.error[name] = message;
            this.$forceUpdate();
        },
        setTab(index) {
            this.tab = index;
        },
        doLogin() {
            var api, data;
            if (this.tab == 1) {
                var username = this.validate('username');
                var password = this.validate('password');
                if (!username || !password) {
                    return false;
                }

                api = 'auth/loginByPasswordForEn';
                if (this.isCn()) {
                    api = "auth/loginByPassword"
                }
                data = {
                    username: this.username,
                    password: this.password,
                    loginType: this.tool.type.checkStr(this.username, 'email') ? 'email' : 'mobile',
                }
            }
            if (this.tab == 2) {
                var phone = this.validate("phone");
                var code = this.validate('code');
                if (!phone || !code) {
                    return false;
                }

                api = 'auth/loginByCodeForEn';
                if (this.isCn()) {
                    api = "auth/loginByCode"
                }
                // 检查是否为邮箱格式
                const isEmail = this.tool.type.checkStr(this.phone, 'email');

                data = {
                    phone: this.phone,
                    code: this.code,
                    loginType: isEmail ? 'email' : 'mobile'
                }
            }

            this.http.request({
                api: api,
                data: data,
                loading: true,
                success: (res) => {
                    if (res.access_token) {
                        this.util.setAccessToken(res.access_token);
                        this.getUserInfo(res.access_token);
                    } else {
                        this.$store.commit('setUserThumb', res.user);
                        this.util.toLink('/registration', this.$route.query);
                    }
                },
                error: (res) => {
                    this.$toast.fail(res.msg);
                }
            })
        },
        getUserInfo(access_token = '') {
            this.http.request({
                api: 'user/getUserInfo',
                data: {
                    access_token: access_token
                },
                loading: true,
                success: (res) => {
                    // 登录用户变量
                    var gioParams = {
                        // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                        // companyName_ppl: res.user.company || "",//公司名称
                        // companyScale_ppl: "",//公司规模
                        // email_ppl: res.user.email || "",//邮箱
                        // industry_ppl: res.user.job || "",//行业
                        // phone_ppl: res.user.phone || "",//手机
                        // userName_ppl: res.user.username || "",//姓名
                        // userRole_ppl: "",//职位
                    };
                    gio('people.set', gioParams);
                    //登录用户ID
                    gio('setUserId', res.user.id);
                    //登录用户类型
                    gio('track', 'loginSuccess',
                        {
                            'user_Id': res.user.memberId,  // memberId
                            'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
                            'loginType': this.tab == 2 ? '短信' : '密码' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                        })
                    // console.log(2,res.user);
                    this.$store.commit('setUserInfo', res.user);
                    this.util.setDellCookie();
                    this.toBack();
                }
            })
        },
        getCode() {
            if (!this.code_status) { return false; }
            var phone = this.validate("phone");
            if (!phone) {
                return false;
            }

            // 检查是否为邮箱格式
            const isEmail = this.tool.type.checkStr(this.phone, 'email');

            var api = "sms/loginForEn";
            if (this.isCn()) {
                api = "sms/login"
            }
            this.http.request({
                api: api,
                type: "POST",
                data: {
                    phone: this.phone,
                    type: isEmail ? 'email' : 'mobile'
                },
                loading: true,
                success: (res) => {
                    this.cutTime();
                },
                error: (res) => {
                    this.$toast.fail(res.msg); return false;
                }
            })
        },
        cutTime() {
            this.code_status = false;
            var number = 59;
            this.code_text = "重新获取(" + number + "s)";
            var timer = setInterval(() => {
                number = number - 1;
                if (number <= 0) {
                    clearInterval(timer);
                    this.code_text = "获取验证码"
                    this.code_status = true;
                } else {
                    this.code_text = "重新获取(" + number + "s)";
                }
            }, 1000)
        },
        toBack() {
            this.util.toBack();
        },
        isCn() {
            return true;
        },
        checkLogin() {
            if (!this.util.getAccessToken()) {
                return false;
            }
            this.http.request({
                api: 'user/getUserInfo',
                async: 1,
                success: (res) => {
                    // 登录用户变量
                    var gioParams = {
                        // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                        // companyName_ppl: res.user.company || "",//公司名称
                        // companyScale_ppl: "",//公司规模
                        // email_ppl: res.user.email || "",//邮箱
                        // industry_ppl: res.user.job || "",//行业
                        // phone_ppl: res.user.phone || "",//手机
                        // userName_ppl: res.user.username || "",//姓名
                        // userRole_ppl: "",//职位
                    };
                    gio('people.set', gioParams);
                    //登录用户ID
                    gio('setUserId', res.user.id);
                    //登录用户类型
                    gio('track', 'loginSuccess',
                        {
                            'user_Id': res.user.memberId,  // memberId
                            'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
                            'loginType': this.tab == 2 ? '短信' : '密码' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                        })
                    // console.log(3,res.user);
                    this.$store.commit('setUserInfo', res.user);
                    this.util.setDellCookie();
                    this.util.toBack();
                }
            })
        }
    },
    mounted() {
        this.query = this.$route.query;
        this.checkLogin();
        this.checkDisasterRecovery(); // 检查灾备状态
        this.util.showBottom(true);
        // if(this.tool.other.getUrlParams('show_password') == 1){
        //     $("#pwlogin").show();
        // }
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
.m-header {
    .top {
        position: fixed;
        height: .88rem;
        overflow: hidden;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 99;
        background: #1D56C0 url("~@/assets/image/2026/mobile/register-login-bg.png") no-repeat top center;
        background-size: 100%;
    }
}

.bg {
    background: #1D56C0 url("~@/assets/image/2026/mobile/register-login-bg.png") no-repeat top center;
    background-size: 100%;
    position: relative;
    padding-bottom: 1rem;

    .banner {
        height: 3.7rem;
        position: relative;

        .top-box {
            text-align: center;

            .title-box {
                padding-top: 1.3rem;
                color: #fff;
                text-align: right;
                position: relative;

                .title {
                    width: 100%;
                    height: 3rem;
                    margin-top: -.5rem;
                    background: url("~@/assets/image/2026/mobile/register-login-kv.png") no-repeat top center;
                    background-size: 100%;
                    margin-left: 0;
                }

                .m-title {
                    display: none;
                    margin-top: -.8rem;

                    .img {
                        width: 2.9rem;
                        height: .35rem;
                        background: url("~@/assets/image/83.png") no-repeat center center;
                        background-size: contain;
                    }
                }

                .logo {
                    position: absolute;
                    bottom: -.7rem;
                    right: .4rem;
                    width: 2.72rem;
                    height: .33rem;
                    background: url("~@/assets/image/logo.png") no-repeat center center;
                    background-size: contain;
                }
            }

            .logo-box {
                position: absolute;
                bottom: .25rem;
                width: 100%;
                display: none;

                .box {
                    float: left;
                    margin-left: .6rem;

                    img {
                        width: 2.35rem;
                    }
                }
            }
        }
    }

    .login-box {
        width: 6.3rem;
        height: 5.3rem;
        margin: .2rem auto 0;
        z-index: 2;
        border-radius: .05rem;
        overflow: hidden;

        .login {
            width: 6.3rem;
            height: 5.3rem;
            background: #fff;

            .tab {
                height: .8rem;
                border-bottom: .02rem solid #f1f1f1;
                box-sizing: border-box;

                .item {
                    float: left;
                    text-align: center;
                    width: 2.2rem;
                    line-height: .8rem;
                    font-size: .28rem;
                    position: relative;
                    transition: all .3s ease;
                    cursor: pointer;
                }

                .item::after {
                    content: "";
                    display: block;
                    width: 1.1rem;
                    height: .06rem;
                    background: #000;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -.55rem;
                    opacity: 0;
                    transition: all .3s ease;
                }

                .item.active {
                    font-weight: bold;
                    transition: all .3s ease;
                }

                .item.active::after {
                    opacity: 1;
                    transition: all .3s ease;
                }
            }

            .info {
                .item {
                    display: none;
                    padding: .5rem .5rem 0;

                    .input {
                        width: 5.3rem;
                        height: .7rem;
                        border: .02rem solid #ddd;
                        border-radius: .05rem;
                        overflow: hidden;
                        position: relative;

                        .icon {
                            display: block;
                            float: left;
                            width: .7rem;
                            height: .7rem;
                        }

                        .icon.icon-user {
                            background: url("~@/assets/image/16.png") no-repeat center center;
                            background-size: .28rem;
                        }

                        .icon.icon-phone {
                            background: url("~@/assets/image/14.png") no-repeat center center;
                            background-size: .28rem;
                        }

                        .icon.icon-message {
                            background: url("~@/assets/image/15.png") no-repeat center center;
                            background-size: .28rem;
                        }

                        .icon.icon-password {
                            background: url("~@/assets/image/password.png") no-repeat center center;
                            background-size: .28rem;
                        }

                        .in {
                            width: 4.4rem;
                            height: .4rem;
                            padding: .15rem .1rem;
                            border: none;
                            background: #fff;
                            font-size: .24rem;
                            color: #000;
                        }

                        .btn {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 1.75rem;
                            height: .7rem;
                            line-height: .7rem;
                            font-size: .24rem;
                            border-left: .02rem solid #ddd;
                            text-align: center;
                            cursor: pointer;
                            background: #fff;
                        }
                    }

                    .validate {
                        height: .4rem;
                        line-height: .4rem;
                        font-size: .22rem;
                        color: red;
                    }

                    .input.error {
                        border-color: #ff0000;
                    }
                }

                .item.active {
                    display: block;
                }

                .submit {
                    width: 5.3rem;
                    height: .7rem;
                    margin: 0 auto 0;
                    line-height: .7rem;
                    text-align: center;
                    color: #fff;
                    font-size: .28rem;
                    background: #1D56C0;
                    border-radius: .05rem;
                    box-shadow: 0 0 .1rem .05rem rgba(1, 118, 206, .1);
                    cursor: pointer;
                    transition: all .3s ease;
                }

                .action {
                    margin: .2rem auto 0;
                    padding: 0 .5rem;

                    .link {
                        height: .4rem;
                        line-height: .4rem;
                        font-size: .24rem;
                        color: #1D56C0;
                        padding: 0 .1rem;
                    }
                }
            }
        }
    }
}
</style>
